<template>
  <div class="service-selection-section">
    <div class="service-cards-container">
      <ServiceCard
        v-for="(service, index) in services"
        :key="index"
        :service="service"
        :selected="selectedServiceId === service.id"
        :show-upgrade="shouldShowUpgrade(service)"
        @select="handleSelect"
      />
    </div>
  </div>
</template>

<script>
import ServiceCard from './ServiceCard.vue';

export default {
  name: 'ServiceSelection',
  components: {
    ServiceCard
  },
  props: {
    services: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedServiceId: {
      type: [String, Number],
      default: null
    },
    actions: {
      type: Array,
      default: () => [
        { type: 'download', label: 'Download', class: 'action-btn-secondary' },
        { type: 'track', label: 'Track', class: 'action-btn-secondary' },
        { type: 'pay', label: 'Pay now £12.50', class: 'action-btn-primary' }
      ]
    }
  },
  emits: ['select', 'action'],
  methods: {
    handleSelect(service) {
      this.$emit('select', service);
    },
    shouldShowUpgrade(service) {
      // Show upgrade button on Executive Service when Standard Car is selected
      return service.id === 'executive' && this.selectedServiceId === 'standard';
    }
  }
};
</script>

<style scoped>
.service-selection-section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.service-cards-container {
  display: flex;
  width: 644px;
  height: 155px;
  gap: 12px;
  opacity: 1;
  margin: 0 auto 24px auto;
}

.action-buttons-row {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.action-btn {
  flex: 1;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.action-btn-secondary {
  background: #1e40af;
  color: #ffffff;
}

.action-btn-secondary:hover {
  background: #1e3a8a;
}

.action-btn-primary {
  background: #79E864;
  color: #000000;
  flex: 2;
}

.action-btn-primary:hover {
  background: #6dd84f;
}

/* Responsive */
@media (max-width: 768px) {
  .service-cards-container {
    flex-direction: column;
    width: 100%;
    max-width: 644px;
    height: auto;
    align-items: center;
  }
}

@media (max-width: 576px) {
  .service-cards-container {
    flex-direction: column;
    width: 100%;
    height: auto;
    gap: 12px;
  }

  .action-buttons-row {
    flex-direction: column;
  }

  .action-btn-primary {
    flex: 1;
  }
}
</style>
